module.exports = __webpack_public_path__ + "img/024-honduras.924e4722.svg";